import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import ServicesHub from "@/pages/ServicesHub";
import ServiceDetail from "@/pages/ServiceDetail";
import AreasHub from "@/pages/AreasHub";
import CityDetail from "@/pages/CityDetail";
import CountyDetail from "@/pages/CountyDetail";
import MatrixDetail from "@/pages/MatrixDetail";
import Capabilities from "@/pages/Capabilities";
import Resources from "@/pages/Resources";
import GuideDetail from "@/pages/GuideDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

const useLenis = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);
};

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) { el.scrollIntoView(); return; }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  useLenis();
  return (
    <div className="App bg-paper min-h-screen">
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<ServicesHub />} />
          <Route path="/services/:serviceSlug" element={<ServiceDetail />} />
          <Route path="/service-areas" element={<AreasHub />} />
          <Route path="/service-areas/tarrant-county" element={<CountyDetail />} />
          <Route path="/service-areas/parker-county" element={<CountyDetail />} />
          <Route path="/service-areas/:citySlug" element={<CityDetail />} />
          <Route path="/service-areas/:citySlug/:serviceSlug" element={<MatrixDetail />} />
          <Route path="/capabilities" element={<Capabilities />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/resources/:guideSlug" element={<GuideDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" toastOptions={{ style: { background: "#26221D", color: "#F7F3E9", border: "1px solid #3B352E", borderRadius: 0 } }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
